import { IConfig } from '@/main';

const appConfig: IConfig = {
  env: {
    apiEndpoint: 'https://api.quickpicks.com/api',
    publicmatchupPath: 'https://s3-eu-west-1.amazonaws.com/replicated.gamedata.quickpicks.com/public',
    matchupEndpoint: 'matchup-list-default.json',
    personalisedEndpoint: 'matchup-list.json',
    historyEndpoint: 'draft-history-',
    userCacheEndpoint: 'profile.json',
    newsEndpoint: 'news-default.json',
    debug: false,
    dsn: 'https://a40f9e2ecbdc481088e4607adbb5dd3f@sentry.io/1863416',
    heapEnv: '749933233',
    mqttPath: 'wss://a2kpzfdzusvqge-ats.iot.us-east-1.amazonaws.com/mqtt',
    mqttRegion: 'us-east-1',
  }
};

export const config = (() => {
  return appConfig.env;
})();

